import { Sentiment } from '@sidecar-components/types'

// These control the sensitivity of the toast for accessibility purposes
// For toasts that are the result of a user action, use 'foreground'.
// For toasts generated from background tasks, use 'background'
export enum ToastType {
  FOREGROUND = 'foreground',
  BACKGROUND = 'background',
}

export interface ToastProps {
  action?: any
  actionAltTag?: string
  actionLabel?: string
  className?: string
  content: any
  /** Per-toast duration in ms */
  duration?: number
  /**
   * Stable identifier for this toast. Passing one lets a toast survive
   * unrelated queue changes (e.g. another toast auto-dismissing) without losing
   * its own identity; omit only if you don't need that guarantee.
   */
  id?: string | number
  label?: string
  open?: boolean
  onOpenChange?: any
  sentiment?: Sentiment
  type?: ToastType
}
